import { HttpEventType } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import readXlsxFile from 'read-excel-file';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { UserModel } from 'src/app/models/authentication/user.model';
import { MaintenanceRoutineSupplyImportModel } from 'src/app/models/imports/maintenance-routine-supply-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { MaintenanceRoutineSupplyService } from 'src/app/services/maintenance/maintenance-routine-supply.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-maintenance-routine-supply-import',
  templateUrl: './maintenance-routine-supply-import.component.html',
  styleUrls: ['./maintenance-routine-supply-import.component.scss'],
  standalone: false,
})
export class MaintenanceRoutineSupplyImportComponent implements OnInit {

  private readonly companyService = inject(CompanyService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly headerService = inject(HeaderService);
  private readonly maintenanceRoutineSupplyService = inject(MaintenanceRoutineSupplyService);
  private readonly router = inject(Router);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly title = inject(Title);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService)

  companyCode: number | null = null;
  companyId: number;
  eventFile: any;
  errorMaintenanceRoutineSupply: number = 0;
  filters: ColumnResponseModel[] = [];
  formImport: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listCompanies: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  maintenanceRoutineSupplyAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>();
  nameWindow: string = 'Importación Insumos de Mantenimiento';
  nameFile: string = 'Ningún archivo seleccionado.';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  url: string = "maintenance-routine-supply-import";
  userAuthenticated: UserModel = new UserModel();
  visibleTxt: boolean = false;

  ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    this.getPermission();
    this.validateForm();
    this.getAllLists();
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.maintenanceRoutineSupplyAlerts || this.maintenanceRoutineSupplyAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.maintenanceRoutineSupplyService.exportImportErrors(this.maintenanceRoutineSupplyAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionInsumosMmto_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.maintenanceRoutineSupplyService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaInsumosMantenimiento.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  async getAllLists() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),

      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getCompany(companyId: number | null) {
    if (companyId != null && companyId != 0) {
      this.companyId = companyId;
      const company = this.listCompanies.find(x => x.value == companyId);
      this.companyCode = company.code;
    } else {
      this.companyCode = null;
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por tipo de impuesto.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
  }

  importMaintenanceRoutineSupply() {
    this.maintenanceRoutineSupplyAlerts = [];
    this.errorMaintenanceRoutineSupply = 0;
    this.visibleTxt = false;
    Object.keys(this.formImport.controls).forEach(key => {
      const control = this.formImport.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formImport.valid) {
      let isOk: boolean = true;
      const input = document.getElementById('fileImport') as any;
      const rowsImport = new Array<MaintenanceRoutineSupplyImportModel>();
      let row: MaintenanceRoutineSupplyImportModel;
      let counter: number = 1, articleCode: number = 0, supplyCode: number = 0, quantityEachUse: number = 0,
        maintenancePlan1: number = 0, maintenancePlan2: number = 0, maintenancePlan3: number = 0,
        maintenancePlan4: number = 0, maintenancePlan5: number = 0, maintenancePlan6: number = 0,
        maintenancePlan7: number = 0, swHomologus: boolean = false, homologusCode: number | null = null;

      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar.`);
            return;
          }
          rows.splice(0, 1);

          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError: boolean = false;

            //A. Código Compañía
            const companyCode = parseFloat(element[0] as string);
            if (isNaN(companyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El código de la Compañía no es válido. `;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            } else {
              if (companyCode != this.companyCode) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna A. La Compañía del archivo no es igual a la Compañía seleccionada.`;
                this.maintenanceRoutineSupplyAlerts.push(alert);
                rowHasError = true;
              }
            }

            //B. Código de Artículo
            articleCode = parseFloat(element[1] as string);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código del Artículo no es válido. `;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //C. Código de Insumo
            supplyCode = parseFloat(element[2] as string);
            if (isNaN(supplyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El código del Insumo no es válido. `;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //D. C/Uso
            quantityEachUse = parseFloat(element[3] as string);
            if (isNaN(quantityEachUse) || quantityEachUse <= 0) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. El campo C/Uso no es válido.`;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //E. Plan 1
            maintenancePlan1 = parseFloat(element[4] as string);
            if (isNaN(maintenancePlan1) || maintenancePlan1 <= 0) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna E. El campo Plan 1 no es válido.`;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //F. Plan 2
            maintenancePlan2 = parseFloat(element[5] as string);
            if (isNaN(maintenancePlan2) || maintenancePlan2 <= 0) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna F. El campo Plan 2 no es válido.`;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //G. Plan 3
            maintenancePlan3 = parseFloat(element[6] as string);
            if (isNaN(maintenancePlan3) || maintenancePlan3 <= 0) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna G. El campo Plan 3 no es válido.`;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //H. Plan 4
            maintenancePlan4 = parseFloat(element[7] as string);
            if (isNaN(maintenancePlan4) || maintenancePlan4 <= 0) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna H. El campo Plan 4 no es válido.`;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //I. Plan 5
            maintenancePlan5 = parseFloat(element[8] as string);
            if (isNaN(maintenancePlan5) || maintenancePlan5 <= 0) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna I. El campo Plan 5 no es válido.`;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //J. Plan 6
            maintenancePlan6 = parseFloat(element[9] as string);
            if (isNaN(maintenancePlan6) || maintenancePlan6 <= 0) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna J. El campo Plan 6 no es válido.`;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //K. Plan 7
            maintenancePlan7 = parseFloat(element[10] as string);
            if (isNaN(maintenancePlan7) || maintenancePlan7 <= 0) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna K. El campo Plan 7 no es válido.`;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }

            //L. Homologus
            if (element[11] as string != "S" && element[11] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna L. El campo Homologo debe ser valores como: S / N.`;
              this.maintenanceRoutineSupplyAlerts.push(alert);
              rowHasError = true;
            }
            swHomologus = element[11] as string === "S";

            //M. Homologus Code
            if (element[12] != null && element[12] != "" && element[11] as string === "S") {
              homologusCode = parseFloat(element[12] as string);
              if (isNaN(homologusCode)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna M. El campo código homólogo no es válido.`;
                this.maintenanceRoutineSupplyAlerts.push(alert);
                rowHasError = true;
              }
            }

            if (!rowHasError) {
              row = new MaintenanceRoutineSupplyImportModel(counter, this.companyId, articleCode, supplyCode, quantityEachUse, maintenancePlan1,
                maintenancePlan2, maintenancePlan3, maintenancePlan4, maintenancePlan5, maintenancePlan6, maintenancePlan7, swHomologus,
                homologusCode);
              rowsImport.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImport.length > 0) {
            try {
              const response = await firstValueFrom(this.maintenanceRoutineSupplyService.importMaintenanceRoutineSupply(rowsImport));
              this.loadPreInvoicingModel = response;
              this.maintenanceRoutineSupplyAlerts = response?.alerts ?? [];
              this.errorMaintenanceRoutineSupply = response?.preInvoicingStateId;
              if (this.errorMaintenanceRoutineSupply === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.maintenanceRoutineSupplyAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar insumos de Rutina de Mantenimiento', error);
            }
          } else {
            this.errorMaintenanceRoutineSupply = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No ha seleccionado ningún archivo.'
        });
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatiria.',
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
    });
  }
}
